import React, {useEffect, useState} from 'react';
import Country from "./Country";
import {CountryPathAndReportProps, ReportDataProps} from "../../../interfaces/RankingsAndLevelsInterfaces";
import RankingsAndLevelsUtils from "../../../services/RankingsAndLevelsUtils";

interface WorldMapProps {
    reportData: ReportDataProps | undefined,
    isLife: boolean
}

const WorldMap: React.FC<WorldMapProps> = ({ reportData , isLife}) => {
    const [svgPaths, setSvgPaths] = useState<CountryPathAndReportProps[]>();

    useEffect(() => {
        if (!reportData) return;
        setSvgPaths(RankingsAndLevelsUtils.generateWorld(reportData, isLife));
    }, [reportData]);

    return (
        <React.Fragment>
            {svgPaths
                ? <svg viewBox='0 0 1400 600' width="100%" height="100%" preserveAspectRatio="xMidYMid meet" style={{ position: 'absolute' }}>
                    <g className='countries' >
                        {
                            svgPaths.map((pathObject: CountryPathAndReportProps, index: number) => (
                                <Country key={index} country={pathObject}/>)
                            )
                        }
                    </g>
                </svg>
                : <svg/>
            }
        </React.Fragment>
    )
};

export default WorldMap;
